import React, { useContext, useState } from "react";
import { API } from "../conf";
import { Context } from "../App";
import { Backdrop, Box, Button, CircularProgress, Stack, TextField, Typography } from "@mui/material";
import { list_repas } from "../conf";

export default function BeneficiaireForm(props) {
    const { updateConnect } = useContext(Context);
    const [load, setLoad] = useState(false);
    const [nom, setNom] = useState(props.beneficiaire?.nom ?? '');
    const [prenoms, setPrenoms] = useState(props.beneficiaire?.prenoms ?? '');
    const [repas, setRepas] = useState(props.beneficiaire?.repas ?? list_repas.map(repas => ({ repas, count: 1 })));
    const [msg, setMsg] = useState();

    async function handleSubmit(event) {
        event.preventDefault();
        setLoad(true);
        setMsg('');
        fetch(API.concat(props.edit ? `/BeneficiaireRepas/by/${JSON.stringify({ _id: props.beneficiaire?._id })}` : '/beneficiaire_repas'), {
            method: props.edit ? 'PATCH' : 'POST',
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + sessionStorage.getItem('token')
            },
            body: JSON.stringify({
                nom, prenoms, repas
            })
        }).then(async response => {
            const token = response.headers.get('x-auth-token');
            if (response.status === 401) {
                sessionStorage.clear();
                updateConnect(false);
            } else {
                if (token && token !== sessionStorage.getItem('token') && token !== '') {
                    sessionStorage.setItem('token', response.headers.get('x-auth-token'));
                }
                if (response.status === 200) {
                    const json = await response.json();
                    props.add(json);
                    props.close();
                    setLoad(false);
                } else {
                    const text = await response.text();
                    setMsg(text);
                    setLoad(false);
                }
            }
        });
    }

    return (
        <Box component='form' onSubmit={handleSubmit} display='flex' flex={1} flexDirection='column'>
            <Typography variant="h5" align="center" marginBottom='5px'>{props.edit ? 'Modifier' : 'Créer'} un bénéficiaire de repas</Typography>
            <Typography align="center" marginBottom='15px' color={'carmine.main'}>{msg}</Typography>
            <Stack direction='column' spacing={2} marginInline='20px'>
                <Stack direction='row' spacing={2} alignItems='center'>
                    <TextField required fullWidth label="Nom" autoComplete="family-name" autoFocus
                        error={/(?:^\s+|\s+$)/.test(nom)} helperText={/(?:^\s+|\s+$)/.test(nom) && "ne doit pas commencer/finir ou ne contenir que des espaces"}
                        sx={{ minWidth: '200px' }} value={nom} onChange={(event) => setNom(event.target.value)} />
                    <TextField required fullWidth label="Prénoms" autoComplete="given-name"
                        error={/(?:^\s+|\s+$)/.test(prenoms)} helperText={/(?:^\s+|\s+$)/.test(prenoms) && "ne doit pas commencer/finir ou ne contenir que des espaces"}
                        sx={{ minWidth: '200px' }} value={prenoms} onChange={(event) => setPrenoms(event.target.value)} />
                </Stack>
                <Typography variant="h6" align="center" marginBottom='5px'>Repas</Typography>
                <Stack direction='row' rowGap={2} columnGap={2} alignItems='center' flexWrap="wrap">
                    {repas.map(repas =>
                    <TextField label={repas.repas} key={repas.repas} type="number" slotProps={{ input: { min: 0 } }}
                        sx={{ minWidth: '150px' }} value={repas.count} 
                        onChange={(event) => setRepas(old=>{
                            const copy = [...old];
                            copy.find(r=>r.repas===repas.repas).count = event.target.value;
                            return copy;
                        })} />
                    )}
                </Stack>
            </Stack>

            <Button variant="contained" type="submit" sx={{ marginTop: '20px', borderRadius: 0, paddingBlock: 1.5 }}>Enregistrer</Button>
            <Backdrop open={load}><CircularProgress /></Backdrop>
        </Box>
    );
}